import Vue from 'vue';
import Vuex from 'vuex';
import counter from '@/store/modules/Counter';
import auth from '@/store/modules/Auth';
import report from '@/store/modules/Report';
import account from '@/store/modules/Account';
import profile from '@/store/modules/Profile';
import balance from '@/store/modules/Balance';
import general from '@/store/modules/General';
import game from '@/store/modules/Game';
import statement from '@/store/modules/Statement';
import suggest from '@/store/modules/Suggest';
import dashboard from '@/store/modules/Dashboard';
import announcement from '@/store/modules/Announcement';
import agentbanner from '@/store/modules/AgentBanner';
import apikey from '@/store/modules/ApiKey';
import userOnline from '@/store/modules/UserOnline';
import social from '@/store/modules/Social';
import bankaccount from '@/store/modules/BankAccount';
import promotion from '@/store/modules/Promotion';
import newlobby from '@/store/modules/NewLobby';
import document from '@/store/modules/Document';
import point from '@/store/modules/Point';
import maintenance from '@/store/modules/Maintenance';
import secretpassword from '@/store/modules/SecretPassword';
import evoplaysessions from '@/store/modules/EvoplaySessions';
import admin from '@/store/modules/Admin';
import gamesmanagement from '@/store/modules/GamesManagement';
import activity from '@/store/modules/Activity';
import cryptoaccount from '@/store/modules/CryptoAccount';
import commissionlog from '@/store/modules/UpdateCommissionLog';
import legendofdolly from '@/store/modules/LegendOfDolly';
import marketingreport from '@/store/modules/MarketingReport';
import user from '@/store/modules/User';
import webmanagement from '@/store/modules/WebManagement';
import domainPool from '@/store/modules/DomainPool';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    counter,
    auth,
    report,
    account,
    profile,
    balance,
    general,
    game,
    statement,
    suggest,
    dashboard,
    announcement,
    agentbanner,
    apikey,
    userOnline,
    social,
    bankaccount,
    promotion,
    newlobby,
    document,
    point,
    maintenance,
    secretpassword,
    evoplaysessions,
    admin,
    gamesmanagement,
    activity,
    cryptoaccount,
    commissionlog,
    legendofdolly,
    marketingreport,
    user,
    webmanagement,
    domainPool,
  },
});
